import React from 'react';
import isEqual from 'lodash/isEqual';
import { Longdash } from '~/utils';
import { useDiffValueClass } from '~/hooks/useDraftDiffContext';
import { DiffType } from '~/utils/diff';

interface HilightChangesProps {
  curr: any;
  prev: any;
  children: any;
  emptyText?: string;
}

const isBlank = (value: any): boolean =>
  value === undefined || value === null || value === '' || isEqual(value, {});

/**
 * Appearing and disappearing are told apart from editing, so the three colours
 * read the same here as everywhere else a draft is compared with the version it
 * replaces.
 */
const diffOf = (curr: any, prev: any): DiffType => {
  if (isEqual(curr, prev)) return 'unchanged';
  if (isBlank(prev)) return 'added';
  if (isBlank(curr)) return 'removed';
  return 'changed';
};

/** Tints a value by how it differs from `prev`. */
const HilightChanges = (props: HilightChangesProps) => {
  const { curr, prev, children, emptyText = Longdash } = props;
  const className = useDiffValueClass(diffOf(curr, prev));

  return <div className={className}>{children || emptyText}</div>;
};

export default HilightChanges;
